module.exports = __webpack_public_path__ + "img/josh-morgan.9bb43f25.png";